import React from 'react';

interface ButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    variant?: 'primary' | 'secondary';
}

export const Button: React.FC<ButtonProps> = ({
    children,
    onClick,
    disabled = false,
    variant = 'primary'
}) => {
    const baseStyle = {
        width: '100%',
        padding: '16px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1
    };

    const primaryStyle = {
        ...baseStyle,
        backgroundColor: '#dc2626',
        color: 'white'
    };

    const secondaryStyle = {
        ...baseStyle,
        backgroundColor: '#f3f4f6',
        color: '#374151'
    };

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            style={variant === 'primary' ? primaryStyle : secondaryStyle}
        >
            {children}
        </button>
    );
};